import { Dialog, Typography, IconButton } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { Close } from '@mui/icons-material'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import UserMeetingTitle from './UserMeetingTitle'
import moment from 'moment'

const UserMeetingTranscript = ({ event, connection, open, setOpen }) => {
  const { t } = useTranslation()
  const mergedTranscript = []
  event?.transcript &&
    event?.transcript?.forEach(dialogue => {
      if (
        mergedTranscript.length > 0 &&
        mergedTranscript[mergedTranscript.length - 1].speaker_id ===
          dialogue.speaker_id
      ) {
        // Append text to the last entry
        mergedTranscript[mergedTranscript.length - 1].text +=
          ' ' + dialogue.words.map(word => word.text).join(' ')
      } else {
        // Create a new entry
        mergedTranscript.push({
          speaker_id: dialogue.speaker_id,
          speaker: dialogue.speaker,
          timestamp: moment(event.startTime)
            .add(dialogue.words[0]?.start_timestamp, 'seconds')
            .format('hh:mm'),
          text: dialogue.words.map(word => word.text).join(' ')
        })
      }
    })
  const transcriptAvailable = mergedTranscript.length > 0

  return (
    <>
      {transcriptAvailable ? (
        <Dialog
          sx={{
            '& .MuiPaper-root': {
              borderRadius: 3,
              position: 'relative',
              width: 580,
              maxHeight: '70vh',
              padding: 12
            }
          }}
          open={open}
          onClose={() => setOpen(false)}>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              color: colors.MidnightTeal400,
              position: 'absolute',
              top: 10,
              right: 10
            }}>
            <Close />
          </IconButton>

          <InCardStack>
            <UserMeetingTitle
              event={event}
              connection={connection}
              titleVariant={'h2'}
              containerProps={{ width: '100%' }}
              avatarSize={44}
              showNoteTakerIcon={false}
            />

            <InCardStack spacing={8} alignItems={'flex-start'}>
              <Typography variant='h3'>{t('rolePlay.transcript')}</Typography>

              <InCardStack spacing={8} alignItems={'flex-start'}>
                {mergedTranscript.map((dialogue, index) => (
                  <RowStack key={`dialogue-${index}`} alignItems={'flex-start'}>
                    <Typography color={colors.Grey300} noWrap width={55}>
                      {dialogue.timestamp}
                    </Typography>
                    <Typography color='textSecondary' flex={1}>
                      <strong>{`${dialogue.speaker}: `}</strong>
                      {dialogue.text}
                    </Typography>
                  </RowStack>
                ))}
              </InCardStack>
            </InCardStack>
          </InCardStack>
        </Dialog>
      ) : (
        <CommonDialog
          open={open}
          onClose={() => setOpen(false)}
          confirmText={t('rolePlay.okay')}
          titleText={t('myTeam.transcriptUnavailable')}
          notificationText={t('myTeam.noteTakerNotAllowed')}
          bodyWidth={440}
          alignItems='left'
        />
      )}
    </>
  )
}

export default UserMeetingTranscript
